import { Controller } from "@hotwired/stimulus"

const COOKIE = "sentinel_theme"
const LIGHT = "sesimi"
const DARK = "sesimi-dark"

export default class extends Controller {
  static targets = ["lightIcon", "darkIcon"]

  declare readonly lightIconTarget: SVGElement
  declare readonly darkIconTarget: SVGElement

  connect(): void {
    this.syncIcon(document.documentElement.dataset.theme || DARK)
  }

  toggle(): void {
    const current = document.documentElement.dataset.theme || DARK
    const next = current === DARK ? LIGHT : DARK
    document.documentElement.dataset.theme = next
    document.cookie = `${COOKIE}=${next}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`
    this.syncIcon(next)
  }

  private syncIcon(theme: string): void {
    const isDark = theme === DARK
    this.lightIconTarget.classList.toggle("hidden", !isDark)
    this.darkIconTarget.classList.toggle("hidden", isDark)
  }
}
